import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { SonarV3SortDirection } from '@sonar-software/sonar-ts-types';
export const picklistSortOptions = [
    {
        direction: 'ascending',
        key: 'name',
        label: COPY_SPECIFIC.NAME
    },
    {
        direction: 'descending',
        key: 'name',
        label: COPY_SPECIFIC.NAME
    }
];
export const v3FieldSortOptions = [
    Object.assign(Object.assign({}, picklistSortOptions[0]), { direction: SonarV3SortDirection.Ascending }),
    Object.assign(Object.assign({}, picklistSortOptions[1]), { direction: SonarV3SortDirection.Descending })
];
